module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-precomposed-6c0c159096e27cb780e32ec56894af22.png";